import { capitalize } from 'lodash/string';
import {
  getListingCategoryById,
  getSportsClubSubCategoryById,
} from '../../../containers/EditListingPage/listingTypeUtils';

export const getActiveFiltersFromSearch = (search, availableFilters) => {
  const params = new URLSearchParams(search);

  const filters = [];

  for (const [key, rawValue] of params.entries()) {
    if (!key.startsWith('pub_') && key !== 'price' && key !== 'keywords') {
      continue;
    }
    const filterConfigMaybe = availableFilters.find(
      f => `pub_${f.key}` === key || key === f.key || key.includes('categoryLevel')
    );

    if (!!!filterConfigMaybe) continue;

    const { filterConfig } = filterConfigMaybe;

    const label = filterConfig?.label || filterConfig?.label || capitalize(key);

    switch (filterConfigMaybe?.schemaType) {
      case 'price':
        const [min, max] = rawValue.split(',');
        filters.push({
          key,
          label: 'Price',
          displayValue: `£${min} – £${max}`,
          rawValue,
        });
        break;
      case 'keywords':
        const words = rawValue.split(',');
        words.forEach(word => {
          filters.push({
            key,
            label: 'Keywords',
            displayValue: 'Keywords: ' + word,
            rawValue: word,
            isPartial: true,
          });
        });
        break;
      case 'category':
        if (key === 'pub_categoryLevel1') {
          filters.push({
            key,
            label,
            displayValue: getListingCategoryById(rawValue)?.pluralLabel,
            rawValue,
          });
        } else if (key === 'pub_categoryLevel2') {
          filters.push({
            key,
            label,
            displayValue: getSportsClubSubCategoryById(rawValue)?.label,
            rawValue,
          });
        }
        break;
      case 'multi-enum':
        if (!!filterConfig?.searchMode) {
          const values = rawValue.replace(`${filterConfig?.searchMode}:`, '').split(',');
          values.forEach(v => {
            const option = filterConfigMaybe?.enumOptions?.find(option => option.option === v);
            filters.push({
              key,
              label,
              displayValue: option?.label || v,
              rawValue: v,
              searchMode: filterConfig?.searchMode,
            });
          });
        }
        break;
      case 'boolean':
        filters.push({
          key,
          label,
          displayValue: label,
        });
        break;
      case 'enum':
        const option = filterConfigMaybe?.enumOptions?.find(option => option.option === rawValue);

        filters.push({
          key,
          label,
          displayValue: option?.label || rawValue,
          rawValue,
        });
        break;
    }
  }

  return filters;
};

export const removeSingleFilter = (filter, location, history) => {
  const params = new URLSearchParams(location.search);

  // Partial removal (multi-enum, keywords)
  if (filter.searchMode) {
    const raw = params.get(filter.key);
    if (!raw) return;

    if (filter.searchMode) {
      const values = raw.replace(`${filter.searchMode}:`, '').split(',');
      const next = values.filter(v => v !== filter.rawValue);

      next.length
        ? params.set(filter.key, `${filter.searchMode}:${next.join(',')}`)
        : params.delete(filter.key);
    } else {
      const values = raw.split(',');
      const next = values.filter(v => v !== filter.rawValue);
      next.length ? params.set(filter.key, next.join(',')) : params.delete(filter.key);
    }
  } else {
    // Full removal
    params.delete(filter.key);
  }

  history.push({
    pathname: location.pathname,
    search: params.toString(),
  });
};
